import { Component } from '@angular/core';
import { HandsetService } from '../../../core/services/handset.service';
import { Router } from '@angular/router';

@Component({
standalone: false,
  selector: 'app-removed-account',
  templateUrl: './removed-account.component.html',
  styleUrls: ['./removed-account.component.scss'],
})
export class RemovedAccountComponent {

  constructor(public handsetService: HandsetService,
              private router: Router) {
  }

  onGoToMain() {
    this.router.navigateByUrl('/auth/login');
  }

}
